<template>
  <div class="container">
    <div class="restoration">
      <h3>{{ $vuetify.lang.t("$vuetify.view.restore.text") }}</h3>
      <div class="restoration__container">
        <div class="restoration__l">
          <p>
            {{
              $vuetify.lang.t(
                "$vuetify.view.restore.deleteHint"
              )
            }}
          </p>
          <v-btn
            style="width: fit-content"
            color="primary"
            @click="processDelete"
          >
            {{ $vuetify.lang.t("$vuetify.view.restore.delete") }}
          </v-btn>
        </div>
        <div class="restoration__r">
          <p>
            {{
              $vuetify.lang.t("$vuetify.view.restore.restoreHint")
            }}
          </p>
          <v-btn
            style="width: fit-content"
            color="primary"
            @click="processRestore"
          >
            {{ $vuetify.lang.t("$vuetify.view.restore.restore") }}
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  name: "restoreComponent",
  methods: {
    processDelete () {
      if (document.body.classList.contains('swal2-toast-shown')) {
        document.body.classList.remove('swal2-toast-shown')
      }
      this.$swal({
        target: document.getElementById("app"),
        title: this.$vuetify.lang.t(
          "$vuetify.view.restore.delete_dialog"
          // "$vuetify.main.psychologistDashboard.schedule.swallCancelSessionByPsychologistTitle"
        ),
        showDenyButton: true,
        confirmButtonText: this.$vuetify.lang.t(
          "$vuetify.main.psychologistDashboard.schedule.swallYes"
        ),
        denyButtonText: this.$vuetify.lang.t(
          "$vuetify.main.psychologistDashboard.schedule.swallNo"
        ),
      }).then(async (result) => {
        if (result.isConfirmed) {
          Vue.swal({
            target: document.getElementById("main"),
            text: this.$vuetify.lang.t(
              "$vuetify.main.psychologistDashboard.schedule.swallCancelSessionByPsychologist"
            ),
            toast: true,
            position: "top-right",
            showConfirmButton: false,
            didOpen: () => {
              Vue.swal.showLoading();
            },
            didClose: () => {},
          });
          
          this.$store
            .dispatch('user/deleteAccount')
            // eslint-disable-next-line no-unused-vars
            .then((response) => {
              if (response.status === 200) {
                Vue.swal({
                  target: document.getElementById("main"),
                  text: this.$vuetify.lang.t(
                    "$vuetify.view.restore.delete_success"
                  ),
                  icon: "success",
                  timer: 4000,
                  toast: true,
                  position: "top-right",
                  showConfirmButton: false,
                });

                this.$router.push('/auth');
              }
            })
            // eslint-disable-next-line no-unused-vars
            .catch((error) => {
              if (error.code === "user_not_exists" || error.code === "invalid_social_token") {
                Vue.swal({
                  target: document.getElementById("main"),
                  text: this.$vuetify.lang.t(
                    "$vuetify.view.restore.user_not_exists"
                  ),
                  icon: "error",
                  timer: 4000,
                  toast: true,
                  position: "top-right",
                  showConfirmButton: false,
                });

                this.$router.replace("/auth");
              } else {
                Vue.swal({
                  target: document.getElementById("main"),
                  text: this.$vuetify.lang.t(
                    "$vuetify.view.restore.error"
                  ),
                  icon: "error",
                  timer: 4000,
                  toast: true,
                  position: "top-right",
                  showConfirmButton: false,
                });
              }
            });
        }

        /* if (result.isDenied) {
          
        } */
      });
    },
    processRestore () {
      this.$store
        .dispatch('user/restoreAccount')
        // eslint-disable-next-line no-unused-vars
        .then((response) => {
          if (response.status === 200) {
            this.$router.push('/dashboard/main');
            Vue.swal({
              target: document.getElementById("main"),
              text: response.data.message,
              icon: "success",
              timer: 4000,
              toast: true,
              position: "top-right",
              showConfirmButton: false,
            });
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch((error) => {
          this.$router.replace("/auth");
        });
    }
  },
  computed: {
    loginProvider () {
      return this.$store.getters['user/getLoginProvider']
    },
  },
};
</script>

<style lang="scss" scoped>
@mixin registrationColumn() {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  justify-content: space-between;
  & > p {
    width: 300px;
    font-weight: 400;
    font-size: 1rem;
    color: $textGray;
  }
}

.container {
  max-width: 1200px !important;
  padding: 20px 15px;
  margin: 0 auto;
}

.restoration {
  max-width: 1200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);
  row-gap: 20px;
  &__container {
    display: flex;
    justify-content: center;
    gap: 4rem;
    flex-wrap: wrap;
    width: 100%;
    margin-top: 30px;
  }
  &__l {
    @include registrationColumn;
  }
  &__r {
    @include registrationColumn;
  }
}
</style>
